import React from 'react';
import { DownloadIcon, BrainIcon, ZapIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="section-dramatic py-20 px-4 border-t border-navy-800" data-id="element-105">
      {/* Atmosphere */}
      <div className="absolute inset-0 bg-flag-overlay opacity-30 z-0 pointer-events-none" data-id="element-106"></div>
      <div className="crowd-bottom opacity-30" data-id="element-107"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4 text-shadow-sm" data-id="element-110">
            Your Path to Unbreakable Courage
          </h2>
          <p className="inline-block bg-navy-900 text-patriot-red font-mono uppercase tracking-widest text-sm px-4 py-1 rounded-full border border-patriot-red/30" data-id="element-111">
            In just 15 minutes a day...
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10 relative" data-id="element-112">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-1 bg-gradient-to-r from-patriot-red/50 via-patriot-blue/50 to-patriot-red/50 z-0 rounded-full" data-id="element-113"></div>

          {/* Step 1 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-114">
            <div className="w-28 h-28 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-patriot-red/50 group-hover:shadow-[0_0_40px_rgba(178,34,52,0.3)] transition-all duration-500 relative bg-navy-900/80" data-id="element-115">
              <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-red-gradient text-white font-black flex items-center justify-center text-lg shadow-lg border-2 border-navy-950" data-id="element-116">
                1
              </div>
              <DownloadIcon className="w-12 h-12 text-patriot-red/80 group-hover:text-patriot-red transition-colors" data-id="element-117" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-3 font-serif" data-id="element-118">
              Instant Download
            </h3>
            <p className="text-slate-300 leading-relaxed text-lg" data-id="element-119">
              Get the PDF optimized for any device immediately after your secure
              purchase. Instant access.
            </p>
          </div>

          {/* Step 2 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-120">
            <div className="w-28 h-28 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-patriot-red/50 group-hover:shadow-[0_0_40px_rgba(178,34,52,0.3)] transition-all duration-500 relative bg-navy-900/80" data-id="element-121">
              <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-red-gradient text-white font-black flex items-center justify-center text-lg shadow-lg border-2 border-navy-950" data-id="element-122">
                2
              </div>
              <BrainIcon className="w-12 h-12 text-patriot-red/80 group-hover:text-patriot-red transition-colors" data-id="element-123" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-3 font-serif" data-id="element-124">
              Strategic Immersion
            </h3>
            <p className="text-slate-300 leading-relaxed text-lg" data-id="element-125">
              Read the warning and understand the patterns of what's coming.
              Prepare your mind for reality.
            </p>
          </div>

          {/* Step 3 */}
          <div className="relative z-10 flex flex-col items-center text-center group" data-id="element-126">
            <div className="w-28 h-28 rounded-full glass-card flex items-center justify-center mb-6 group-hover:border-patriot-red/50 group-hover:shadow-[0_0_40px_rgba(178,34,52,0.3)] transition-all duration-500 relative bg-navy-900/80" data-id="element-127">
              <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-red-gradient text-white font-black flex items-center justify-center text-lg shadow-lg border-2 border-navy-950" data-id="element-128">
                3
              </div>
              <ZapIcon className="w-12 h-12 text-patriot-red/80 group-hover:text-patriot-red transition-colors" data-id="element-129" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-3 font-serif" data-id="element-130">
              Conscious Action
            </h3>
            <p className="text-slate-300 leading-relaxed text-lg" data-id="element-131">
              Apply the principles of civic courage in your daily life. Become
              the beacon of your community.
            </p>
          </div>
        </div>
      </div>
    </section>;
}